(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["back-to-top"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-back-to-top]') : null;
    if (!link) return;

    event.preventDefault();
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    // Horizon may scroll the page wrapper instead of the document, so reset whichever is scrolled.
    for (const scroller of [document.scrollingElement, document.querySelector('.page-wrapper')]) {
      if (scroller && scroller.scrollTop > 0) scroller.scrollTo({ top: 0, behavior });
    }
    // The header group wrapper can't hold focus, so hand it to the first visible header control (usually the logo).
    for (const control of document.querySelectorAll('#header-group :is(a[href], button, summary)')) {
      const visible = control.checkVisibility ? control.checkVisibility() : control.offsetParent !== null;
      if (!visible) continue;
      control.focus({ preventScroll: true });
      if (document.activeElement === control) break;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
